import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';

import { ManagersEffectsModule } from '@appStore/managers/effects';
import { reducers } from '@appStore/managers/reducers';
import * as fromServices from '@appStore/managers/services';

export * from '@appStore/managers/reducers';
export * from '@appStore/managers/effects';
export * from '@appStore/managers/actions';

@NgModule({
  imports: [CommonModule, StoreModule.forFeature('managers', reducers), ManagersEffectsModule],
  providers: [...fromServices.services]
})
export class ManagersStoreModule {}
